import zod from 'zod'

export const hemodynamicMeasurementsSchema = zod.object({
  restingHeartFrequencyInWater: zod.number().min(0),
  maxHeartFrequency: zod.number().min(1),
  restingHeartFrequency: zod.number().min(1),
  hasInWaterPrescription: zod.boolean(),
})
